<template>
</template>

<script>
import QRScanner from 'cordova-plugin-qrscanner'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'QRscan',
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      device: 'global/device',
    }),
  },
  methods: {
    ...mapActions({
      checkin: 'checkin/checkin'
    }),
    async onCheckin(code) {
      try { 
        const { data } = await this.checkin(code)
        if(data.hcode === "ok") {        
          let d = data.data
          if(d.shopInfo) {
            this.$router.push({ name: 'shop', params: { id: d.shopInfo.oid } })
          } else {
            this.$router.back()
          }          
        } else {          
          this.$toasted.show(data.msg, { type: 'error' })
        }
     } catch (errors) {
       console.error("Error:", errors)
       this.$toasted.show('Qualcosa è andato storto!', { type: 'error' })
      }
    }
  },
  beforeDestroy() {
    document.getElementsByTagName("HTML")[0].classList.remove('scan-active')
    document.addEventListener('deviceready', () => {
      window.QRScanner.destroy(status => {
        console.log(status);
      });
    }, false)
  },
  mounted() {

    let _this = this

    if(!this.device) {
      this.onCheckin("5edf4bc3cd9be410f5280088")
      return
    }

    document.addEventListener('deviceready', () => {
      
      window.QRScanner.prepare(onDone)
    
      function onDone(err, status){      
        if (err) {
            // here we can handle errors and clean up any loose ends.
            console.error(err);
        }
        if (status.authorized) {
            
            document.getElementsByTagName("HTML")[0].classList.add('scan-active')
      
            // window.QRScanner.show();
            window.QRScanner.show(function(status){
                window.QRScanner.scan(displayContents);
            });
            // window.QRScanner.scan(displayContents);
        } else if (status.denied) {
            // The video preview will remain black, and scanning is disabled. We can
            // try to ask the user to change their mind, but we'll have to send them
            // to their device settings with `QRScanner.openSettings()`.
        } else {
            // we didn't get permission, but we didn't get permanently denied. (On
            // Android, a denial isn't permanent unless the user checks the "Don't
            // ask again" box.) We can ask again at the next relevant opportunity.
        }
      }
      
      async function displayContents(err, text){
        if(err){
            // an error occurred, or the scan was canceled (error code `6`)
        } else {
            
            await _this.onCheckin(text)
      
            window.QRScanner.hide(status => {
              document.getElementsByTagName("HTML")[0].classList.remove('scan-active')
            });

            window.QRScanner.destroy(status => {
              console.log(status);
            });
        }
      }
      
    }, false);

  }  
}
</script>

<style lang="scss">
html.scan-active {
  background-color: rgba(0,0,0,0.5);  
  &::before {
    content: '';
    width: 250px;
    height: 250px;
    top: 150px;
    left: 50%;
    position: absolute;
    //background-size: contain;
    //background-image: url('https://softwarb.blog/assets/softwarb_qr_scanner_white.png');
    //background-repeat: no-repeat;
    //background-position: 50%;
    transform: translate(-50%);
    border: #fff 5px dotted;
  }
}

.scan-active .md-app-scroller {
  opacity: 0;
}
.scan-active .md-app {
  background-color: transparent !important;
}

.scan-active #app {
  background-color: transparent !important;
}
</style>


// WEBPACK FOOTER //
// src/modules/common/components/checkin/QRscan.vue